<template>
    <div class="container" :class="{'mt-11' : !$mq.isDesktop()}">
    	<div class="pt-5 verify-ct">
	        <div class="bg">

	            <section v-if="state == 'error'">

	                <p class="gif-container">
	                    <img src="https://api.quomi.it/oldimg/albero-piantato.gif">
	                </p>

	                <div>
	                    <h2
	                        class="center"
	                        v-html="`Ops! Si è verificato un errore`"
	                    />
	                    <p>
	                        Si è verificato un errore: {{ error }}.
	                    </p>
	                </div>
	            </section>
	            <section v-if="state == 'confirmed'">
	                <div>
	                    <h2
	                        class="mt-2"
	                        v-html="`Ordine per ${$_dates_readableDate(order.date.delivery)}`"
	                    />

	                    <p>
	                       	La consegna è prevista per il giorno <strong>{{ order && $_dates_readableDate(order.date.delivery) }}</strong> nella fascia <strong>{{ $_date_readableDateHour()}}</strong> <br>

	                        <span
	                          v-if="(address && delivery)"
	                        >
	                            a <span>{{ delivery.name }}, </span> <span v-if="address.name">{{ address.name }}, </span> <span>{{ address.street }}, {{ address.zip_code }}, {{ address.city }}</span>
	                        </span>

	                    </p>
	                </div>

	                <div
	                    class="link-detail link-big-detail"
	                    @click="showDelivery = !showDelivery"
	                >
	                    <b >+ Vuoi modificare il giorno o l'indirizzo di consegna? Clicca qui</b>
	                </div>
	                <change-delivery v-show="showDelivery" />
	                <div
	                    class="link-detail link-big-detail coupon-detail-info"
	                    @click="$refs.couponSection.toggle()"
	                >
	                    <b>{{ $t("components.payment.coupon_link") }}</b>
	                </div>

	                <add-coupon
	                    :centered="true"
	                    ref="couponSection"
	                    v-if="order"
	                    :openedOnLoad='false'
	                    :order.sync="order"
	                    :redirect="true"
	                />
                  <pellegrini />
	                <edenred :force="true"/>
	                <payment-cards v-on:changed="setMethod" class="mr-5"/>
									<flash
									:flash="flash"
									:state="flashState ? `success` : `error`"					
									/>
	                <!--<subscription-recurring-change :compact="true" />-->
	                <div class="flex pr-5" style="justify-content:flex-end">
				        <div v-if="!method">

								<CTA
									isWithLoader
									@click="done()"
									:content="`Conferma ordine <i class='fas fa-angle-right' />`" 

								/>
				        	
				        </div>
				    </div>

				  <div class="icons mr-4 mt-3" style="display:flex; justify-content:flex-end">
	                    <img src="https://api.quomi.it/oldimg/sigillo-netcomm.png" class="netcomm" height='42'>
	                    <img src="https://api.quomi.it/oldimg/certificato-ssl2.png" alt='ssl' class="ssl" style='max-height:52px; width: auto'>
	                </div>

	                <div class="partner">
	                  <p class='gray conditions'>
	                      Confermando il tuo ordine dichiari di essere maggiorenne e di aver preso visione e accettato integralmente
	                      <router-link
	                        :to="{name: 'legal'}"
	                        target='_blank'
	                        class="link-detail"
	                        :title="$t('auth.checkbox.general_conditions')"
	                        v-html="`Condizioni generali di vendita`"
	                      />
	                      e la
	                      <router-link
	                        :to="{name: 'privacy-policy'}"
	                        class="link-detail"
	                        :title="$t('auth.checkbox.privacy')"
	                        target='_blank'
	                        v-html="`Privacy policy`"
	                      />
	                      di Quomi.</p>

	                  <p class="gray small-text">&#127795; Pianteremo un albero in partnership con “Eden Reforestation Projects” per ogni ordine che effettuerai sul nostro sito.</p>
	                </div>

	            </section>
	        </div>
	        <div class="bg" id="checkout-bill" :style="$mq.isDesktop() ? 'min-width: 330px' : ''">
                <div
                    is="CheckoutBill"
                />
          </div>
	    </div>
	    <br><br>
			<checkout-footer :verifyPageFooter="true"/>
	</div>
</template>

<script>
import EcommerceSlider from '../Ecommerce/EcommerceSlider'
import AddCoupon from './AddCoupon'
import Edenred from './Edenred'
import Pellegrini from './Pellegrini'
import { OrderApi } from '../../api/OrderApi'
import { dates } from '../../mixins/dates'
import { prices } from '../../mixins/prices'
import Flash from '../Parts/Flash'
import { container } from '../../services/container'
import CheckoutFooter from './CheckoutFooter'
import CTA from '../Elements/CTA'
import Typeform from '../Profile/Typeform' 
import { orderStore } from '../../store/orderStore'
import ChangeDelivery from '../Delivery/ChangeDelivery'
import { deliveryStore } from '../../store/deliveryStore'
import SubscriptionRecurringChange from './SubscriptionRecurringChange'
import PaymentCards from '../Profile/PaymentCards'
import CheckoutBill from './CheckoutBill'

export default {
	components: {
		CheckoutBill,
		PaymentCards,
		SubscriptionRecurringChange,
		ChangeDelivery,
		EcommerceSlider,
		AddCoupon,
		Typeform,
		Edenred,
    Pellegrini,
		CTA,
		Flash,
		CheckoutFooter
	},

	mixins: [
        dates,
        prices
    ],

	data () {
		return {
            prio: true,
            state: 'loading',
            showDelivery: false,
            deliveryStore: deliveryStore.state,
            extras: null,
            error: null,
            method: null,
						flash: null,
						flashState: null
		}
	},

	computed: {
    edenredState () {
        return {
            confirmed: this.orderHasEdenred,
            estimated: this.edenredTicketEstimated,
            authorized: this.edenredTicketEstimated || this.orderHasEdenred
        }
    },
    address () {

        return this.delivery
            && this.deliveryStore
            && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id)
            && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id).attributes
    },

    delivery () {
        var sub = this.user.subscription
        return this.deliveryStore
            && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id)
            && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id).attributes
    },


    user () {
        return this.$root.user
    },

    order () {
        return this.user.order
    },

    dateCheckout () {
    	return this.$_dates_readableDate(this.order.date.checkout)
    },

    isEcommerce () {
    	return this.$route.name === 'thank-you-ecommerce' || this.$route.name === 'ecommerce'
    },

    alreadySeen () {
        if (!this.order || !this.order.id) return false
        return container.get('services.cookies').get('typeform_ty') === this.order.id.toString()
    },
	},

    methods: {
    	setMethod(method) {
    		this.method = method
    	},
        openTypeform () {
            if (this.$refs.typeform && !this.alreadySeen) this.$refs.typeform.open()
        },

        onTypeformSubmit () {
            if (this.order) container.get('services.cookies').set('typeform_ty', this.order.id)
        },

        errorState (msg) {
            this.error = msg
            this.state = 'error';
        },
        done() {

            window.dispatchEvent(new CustomEvent('verify-page-confirmed', { 
                bubbles: true,
            }));

            window.dispatchEvent(new CustomEvent('checkout-change-menu', { 
                bubbles: true,
                detail: (status) => {
                	
        			if (status === false) {
        				return
        			}
        			
        			this.$router.push({name: 'thank-you-recurring'})
        			
                }
            }));
        },
    },

    mounted () {
				this.flash = null
				this.flashState = null
        this.state = 'confirmed';
        // force refresh user
        orderStore.state.order = this.order;
        orderStore.retrieveOrder().then(i => {
            this.user.order = orderStore.state.order 
        })

        this.openTypeform()
				if(this.$route.query.token && this.user.subscription.paypal_status == 'pending') {
					var api = new OrderApi()
		    	api.confirmPaypal({
		      paypal_token: this.$route.query.token,
		      subscription_token: this.user.subscription.token
		    }).then(response => {
					this.user.subscription.payment_method = 'paypal'
					this.flashState = true
					this.flash = "Il metodo di pagamento è stato aggiornato correttamente";
					setTimeout(()=> {
						this.flash = null
						this.flashState = null
					},1500)
				}).catch(response => {
					this.flashState = false
					this.flash = "Il metodo di pagamento non è stato aggiornato";
					setTimeout(()=> {
						this.flash = null
						this.flashState = null
					},1500)
				})
				}
    }
}

</script>

<style scoped>
    .label {
        background-color: #fbf1d7;
        max-width: 500px;
        margin: 0 auto;
        margin-bottom: 10px;
    }

    .bg {
        background: white;
		box-shadow: 0 5px 4px 0 rgba(0,0,0,.26);
		padding: 10px 25px;
		margin: 0 20px;
    }

    .content {
        padding: 30px 15px 30px 15px;
        text-align: left;
        width: 100%;
        max-width: 800px;
        margin: 0;
    }

    .gif-container {
        width: 100px;
        height: 100px;
        margin: 0 auto;
        border-radius: 50%;
        overflow: hidden;
        margin-bottom: 20px;
    }

    .gif-container img {
        max-width: inherit;
        margin-left: -16px;
    }


    h2 {
        padding-bottom: 10px;
    }

    h3 {
        font-size: 20px;
    }

    .red-text {
        margin: 0 auto;
        display: block;
        font-size: 15px;
        font-weight: bold;
    }

    section {
        padding: 0px 0;
        width: 100%;
    }

	.gray {
	  opacity: 0.7;
	  font-size: 11px;
	  line-height: 11px !important;
	}


	.conditions {
	    margin: 10px 0 5px 0;
	    cursor: pointer;
	}

	.verify-ct {
		display:flex;
		margin: 0 auto;
		max-width: 1200px
	}

	@media (max-width: 1024px) {
		.verify-ct {
			flex-wrap: wrap;
		}
		.bg {
			width: 100%;
			margin-bottom: 30px;
		}
	}
</style>
